import About from "./About";

const Index = () => {
    return <About />;
}

export default Index;
